module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-main"
  }, [(!_vm.formSubmitted) ? _c('form', {
    staticClass: "form-main__form",
    attrs: {
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.validate($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-main__group"
  }, [_c('label', {
    staticClass: "form-main__label",
    class: {
      'form-main__label--active': _vm.name
    }
  }, [_vm._v("Name    ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_spaces'),
      expression: "'required|alpha_spaces'"
    }],
    staticClass: "form-main__input",
    class: {
      'form-main__input--error': _vm.errors.has('name')
    },
    attrs: {
      "name": "name",
      "placeholder": "Name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('name')),
      expression: "errors.has('name')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("Your name is required.")])]), _c('div', {
    staticClass: "form-main__group"
  }, [_c('label', {
    staticClass: "form-main__label",
    class: {
      'form-main__label--active': _vm.email
    }
  }, [_vm._v("Email    ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "form-main__input",
    class: {
      'input': true, 'form-main__input--error': _vm.errors.has('email')
    },
    attrs: {
      "name": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(" Please Input a Valid E-mail")])]), _c('div', {
    staticClass: "form-main__group form-main__group--phone"
  }, [_c('label', {
    staticClass: "form-main__label",
    class: {
      'form-main__label--active': _vm.phone
    }
  }, [_vm._v("Phone Number    ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }],
    staticClass: "form-main__input",
    class: {
      'input': true, 'form-main__input--error': _vm.errors.has('clientPhone')
    },
    attrs: {
      "name": "phone",
      "placeholder": "Phone"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('phone')),
      expression: "errors.has('phone')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("Please Input a Valid Phone Number, Only Numbers")])]), _c('div', {
    staticClass: "form-main__group form-main__group--select"
  }, [_c('label', {
    staticClass: "form-main__label form-main__label--select",
    class: {
      'form-main__label--active': _vm.location
    }
  }, [_vm._v("Location")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.location),
      expression: "location"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-main__select form-main__input",
    class: {
      'input': true, 'form-main__group--error': _vm.errors.has('location')
    },
    attrs: {
      "name": "location",
      "placeholder": "Choose Location"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.location = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "disabled",
      "selected": "selected",
      "value": ""
    }
  }, [_vm._v("Choose Location")]), _c('option', {
    attrs: {
      "value": "Grand Prairie office"
    }
  }, [_vm._v("Grand Prairie office")]), _c('option', {
    attrs: {
      "value": "Midlothian office"
    }
  }, [_vm._v("Midlothian office")]), _c('option', {
    attrs: {
      "value": "Dallas office"
    }
  }, [_vm._v("Dallas office")])]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('location')),
      expression: "errors.has('location')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('location')) + "   ")])]), _c('div', {
    staticClass: "form-main__group"
  }, [_c('div', {
    staticClass: "form-main__submit-btn active",
    on: {
      "click": _vm.validate
    }
  }, [_vm._v("Send")])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8a52127e"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/form/form.pug
// module id = 529
// module chunks = 1